import React from "react";
import Skeleton from "../../skeleton";

const Dekstop = () => (

	<>
		<div className="card-skeleton-tab-article">
			<div className="card-skeleton-tab-article__section-article">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-article__article">
					{Array.from({ length: 9 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-article__article-data">
							<Skeleton
								width="312px"
								height="208px"
							/>
							<div className="card-skeleton-tab-article__article-description">
								<Skeleton
									width="312px"
									height="20px"
								/>
								<Skeleton
									width="297px"
									height="20px"
								/>
								<Skeleton
									width="154px"
									height="20px"
								/>
							</div>
						</div>
					))}
				</div>
				<div className="card-skeleton-tab-article__article-button">
					<Skeleton
						width="240px"
						height="40px"
						margin="auto"
					/>
				</div>
			</div>
		</div>
		<style jsx>
			{`
				.card-skeleton-tab-article{
					max-width: 1280px;
					margin-top: 38px;
				}
				.card-skeleton-tab-article__section-article {
					margin-top: 38px;
				}
				.card-skeleton-tab-article__article-data {
					margin-bottom: 20px;
				}
				.card-skeleton-tab-article__article {
					margin-top: 18px;
					display: grid;
					grid-template-columns: repeat(3, 1fr);
				}
				.card-skeleton-tab-article__article-button{
					margin-top: 41px;
					display: flex;
					align-items: center;
					justify-content: center;
				}

		`}
		</style>
	</>

);

export default Dekstop;
